// EmailJS Configuration for Stepper Forms

// EmailJS Public Key
export const EMAILJS_PUBLIC_KEY = "DyDZ85E9uwzwSyUoD";

// Service IDs
export const EMAILJS_SERVICE_ID = "service_4kan9lv";
export const EMAILJS_ADMIN_SERVICE_ID = "service_ssbinbm";

// Template IDs
export const TEMPLATE_IDS = {
  // Stepper form templates
  STEPPER_FORM_ADMIN: "template_mnhb9lx",
  STEPPER_FORM_CONFIRMATION: "template_ex2ix8w",
  
  // PDF form templates
  PDF_FORM_ADMIN: "template_uhpo60t",
  PDF_FORM_USER: "template_7qjmp75",
  
  // Claim Review form templates
  CLAIM_REVIEW_ADMIN: "template_qk61rqu",
  CLAIM_REVIEW_USER: "template_a27ylht",
  
  // HTML version templates (optional)
  STEPPER_FORM_ADMIN_HTML: "template_mnhb9lx",
  STEPPER_FORM_CONFIRMATION_HTML: "template_ex2ix8w",
  PDF_FORM_ADMIN_HTML: "template_uhpo60t",
  PDF_FORM_USER_HTML: "template_7qjmp75",
  CLAIM_REVIEW_ADMIN_HTML: "template_claim_review_admin",
  CLAIM_REVIEW_USER_HTML: "template_claim_review_user"
};

// Email addresses
export const EMAIL_ADDRESSES = {
  ADMIN: "reachus@fightformesothelioma.com",
  FROM: "reachus@fightformesothelioma.com"
};

// Page types for tracking
export const PAGE_TYPES = {
  NEVADA: "Nevada Landing Page",
  CALIFORNIA: "California Landing Page", 
  COLORADO: "Colorado Landing Page",
  PDF_DOWNLOAD: "PDF Download Page"
};

// Form field mappings
export const FORM_FIELD_MAPPINGS = {
  accidentType: {
    car: "Car",
    truck: "Pickup Truck"
  },
  injuryLevel: {
    mild: "Mild Injury",
    serious: "Serious Injury", 
    death: "Death"
  },
  whoWasInAccident: {
    me: "I was in the accident",
    caretaker: "I am the Caretaker"
  },
  whoWasAtFault: {
    injured: "Injured Person",
    "someone-else": "Someone else",
    "dont-know": "I don't know"
  },
  // PDF form specific mappings
  consentStatus: {
    true: "Yes - Express written consent given",
    false: "No"
  }
};

// EmailJS initialization
export const initializeEmailJS = () => {
  console.log('🔧 Initializing EmailJS...')
  console.log('🌐 Window available:', typeof window !== 'undefined')
  console.log('📧 EmailJS available:', window.emailjs ? 'Yes' : 'No')
  console.log('🔑 Public key:', EMAILJS_PUBLIC_KEY)
  
  if (typeof window !== 'undefined' && window.emailjs) {
    try {
      window.emailjs.init(EMAILJS_PUBLIC_KEY);
      console.log('✅ EmailJS initialized successfully')
    } catch (error) {
      console.error('❌ Error initializing EmailJS:', error)
    }
  } else {
    console.warn('⚠️ EmailJS not available for initialization')
  }
};

// Template variable formatters
export const formatTemplateVariables = (formData, pageType) => {
  const currentDate = new Date();
  const pagePath = typeof window !== 'undefined' ? window.location.pathname : "Unknown";
  const fullPageUrl = typeof window !== 'undefined' ? window.location.href : "Unknown";
  
  return {
    // Form data
    full_name: formData.fullName || "Not provided",
    phone_number: formData.phoneNumber || "Not provided", 
    email: formData.email || "Not provided",
    accident_type: FORM_FIELD_MAPPINGS.accidentType[formData.accidentType] || "Not specified",
    injury_level: FORM_FIELD_MAPPINGS.injuryLevel[formData.injuryLevel] || "Not specified",
    who_was_in_accident: FORM_FIELD_MAPPINGS.whoWasInAccident[formData.whoWasInAccident] || "Not specified",
    who_was_at_fault: FORM_FIELD_MAPPINGS.whoWasAtFault[formData.whoWasAtFault] || "Not specified",
    consent_given: formData.consent ? "Yes" : "No",
    
    // Technical data
    page_type: pageType,
    page_path: pagePath,
    full_page_url: fullPageUrl,
    submission_date: currentDate.toLocaleDateString(),
    submission_time: currentDate.toLocaleTimeString(),
    
    // Email configuration
    from_name: formData.fullName || "Anonymous",
    from_email: EMAIL_ADDRESSES.FROM,
    to_email: EMAIL_ADDRESSES.ADMIN,
    subject: `New ${pageType} Case Review Submission`
  };
};

// Validation functions
export const validateFormData = (formData) => {
  const errors = [];
  
  if (!formData.fullName) {
    errors.push("Full name is required");
  }
  
  if (!formData.phoneNumber) {
    errors.push("Phone number is required");
  }
  
  if (!formData.accidentType) {
    errors.push("Accident type is required");
  }
  
  if (!formData.injuryLevel) {
    errors.push("Injury level is required");
  }
  
  if (!formData.whoWasInAccident) {
    errors.push("Who was in accident is required");
  }
  
  if (!formData.whoWasAtFault) {
    errors.push("Who was at fault is required");
  }
  
  if (!formData.consent) {
    errors.push("Consent is required");
  }
  
  return {
    isValid: errors.length === 0,
    errors
  };
};

// Email sending configuration
export const EMAIL_CONFIG = {
  // Retry settings
  maxRetries: 3,
  retryDelay: 1000, // 1 second
  
  // Timeout settings
  timeout: 10000, // 10 seconds
  
  // Success/error messages
  messages: {
    success: "Thank you! We'll contact you soon.",
    error: "There was an error submitting your form. Please try again.",
    networkError: "Network error. Please check your connection and try again."
  }
};

// Template variable formatters for PDF form
export const formatPdfFormTemplateVariables = (formData, pageType = PAGE_TYPES.PDF_DOWNLOAD) => {
  const currentDate = new Date();
  const pagePath = typeof window !== 'undefined' ? window.location.pathname : "Unknown";
  const fullPageUrl = typeof window !== 'undefined' ? window.location.href : "Unknown";
  
  return {
    // Form data
    full_name: formData.fullName || "Not provided",
    phone_number: formData.phone || "Not provided",
    email: formData.email || "Not provided",
    consent_given: FORM_FIELD_MAPPINGS.consentStatus[formData.consent] || "No",
    
    // Technical data
    page_type: pageType,
    page_path: pagePath,
    full_page_url: fullPageUrl,
    submission_date: currentDate.toLocaleDateString('en-US', {
      weekday: 'long',
      year: 'numeric',
      month: 'long',
      day: 'numeric'
    }),
    submission_time: currentDate.toLocaleTimeString('en-US', {
      hour: '2-digit',
      minute: '2-digit',
      second: '2-digit',
      hour12: true
    }),
    
    // Email configuration
    from_name: formData.fullName || "PDF Download User",
    from_email: EMAIL_ADDRESSES.FROM,
    to_email: EMAIL_ADDRESSES.ADMIN,
    subject: `New PDF Download Request - ${formData.fullName || 'Anonymous'}`
  };
};

// Validation functions for PDF form
export const validatePdfFormData = (formData) => {
  const errors = [];
  
  if (!formData.fullName || formData.fullName.trim().length < 2) {
    errors.push("Full name is required (minimum 2 characters)");
  }
  
  if (!formData.fullName || !formData.fullName.includes(' ')) {
    errors.push("Please enter your full name (first and last name)");
  }
  
  if (!formData.email || !formData.email.includes('@')) {
    errors.push("Valid email address is required");
  }
  
  if (!formData.phone) {
    errors.push("Phone number is required");
  }
  
  const phoneDigits = formData.phone ? formData.phone.replace(/\D/g, '') : '';
  if (phoneDigits.length !== 10) {
    errors.push("Valid 10-digit phone number is required");
  }
  
  if (!formData.consent) {
    errors.push("Consent to terms and conditions is required");
  }
  
  return {
    isValid: errors.length === 0,
    errors
  };
};

// Enhanced email sending function with retry logic for 412 errors
const sendEmailWithRetry = async (serviceId, templateId, templateVars, publicKey, maxRetries = 3) => {
  let lastError;
  
  for (let attempt = 1; attempt <= maxRetries; attempt++) {
    try {
      console.log(`📧 Email attempt ${attempt}/${maxRetries}`);
      
      // Add a small delay between retries to avoid rate limiting
      if (attempt > 1) {
        const delay = Math.pow(2, attempt - 1) * 1000; // Exponential backoff
        console.log(`⏳ Waiting ${delay}ms before retry...`);
        await new Promise(resolve => setTimeout(resolve, delay));
      }
      
      // Validate template variables before sending
      const sanitizedVars = sanitizeTemplateVariables(templateVars);
      
      const result = await window.emailjs.send(
        serviceId,
        templateId,
        sanitizedVars,
        publicKey
      );
      
      console.log(`✅ Email sent successfully on attempt ${attempt}`);
      return { success: true, result, attempt };
      
    } catch (error) {
      lastError = error;
      console.error(`❌ Email attempt ${attempt} failed:`, error);
      
      // Check if it's a 412 error or other retryable error
      const isRetryableError = error.status === 412 || 
                              error.status === 429 || 
                              error.status >= 500 ||
                              error.message?.includes('network') ||
                              error.message?.includes('timeout');
      
      if (!isRetryableError || attempt === maxRetries) {
        console.error(`💥 Final attempt failed or non-retryable error:`, error);
        break;
      }
      
      console.log(`🔄 Retrying due to ${error.status || 'network'} error...`);
    }
  }
  
  return { 
    success: false, 
    error: lastError?.message || 'Unknown error',
    status: lastError?.status,
    attempts: maxRetries
  };
};

// Sanitize template variables to prevent issues
const sanitizeTemplateVariables = (vars) => {
  const sanitized = {};
  
  for (const [key, value] of Object.entries(vars)) {
    if (value === null || value === undefined) {
      sanitized[key] = '';
    } else if (typeof value === 'string') {
      // Remove any potentially problematic characters
      sanitized[key] = value.trim().replace(/[\r\n\t]/g, ' ');
    } else {
      sanitized[key] = value;
    }
  }
  
  return sanitized;
};

// Email sending functions for PDF form
export const sendPdfFormAdminEmail = async (formData) => {
  try {
    if (typeof window === 'undefined' || !window.emailjs) {
      throw new Error('EmailJS not available');
    }

    const templateVars = formatPdfFormTemplateVariables(formData);
    
    const result = await sendEmailWithRetry(
      EMAILJS_SERVICE_ID,
      TEMPLATE_IDS.PDF_FORM_ADMIN,
      templateVars,
      EMAILJS_PUBLIC_KEY
    );
    
    if (result.success) {
      console.log('Admin email sent successfully:', result);
    } else {
      console.error('Admin email failed after all retries:', result);
    }
    
    return result;
  } catch (error) {
    console.error('Failed to send admin email:', error);
    return { success: false, error: error.message };
  }
};

export const sendPdfFormUserEmail = async (formData) => {
  try {
    if (typeof window === 'undefined' || !window.emailjs) {
      throw new Error('EmailJS not available');
    }

    const templateVars = formatPdfFormTemplateVariables(formData);
    
    const result = await sendEmailWithRetry(
      EMAILJS_SERVICE_ID,
      TEMPLATE_IDS.PDF_FORM_USER,
      templateVars,
      EMAILJS_PUBLIC_KEY
    );
    
    if (result.success) {
      console.log('User confirmation email sent successfully:', result);
    } else {
      console.error('User confirmation email failed after all retries:', result);
    }
    
    return result;
  } catch (error) {
    console.error('Failed to send user confirmation email:', error);
    return { success: false, error: error.message };
  }
};

// Admin email function using the additional service ID
export const sendAdminEmailWithSecondaryService = async (formData) => {
  try {
    console.log('🔍 Starting sendAdminEmailWithSecondaryService...');
    console.log('📧 Service ID:', EMAILJS_ADMIN_SERVICE_ID);
    console.log('📧 Template ID:', TEMPLATE_IDS.PDF_FORM_ADMIN);
    console.log('🔑 Public Key:', EMAILJS_PUBLIC_KEY);
    
    if (typeof window === 'undefined' || !window.emailjs) {
      throw new Error('EmailJS not available');
    }

    const templateVars = formatPdfFormTemplateVariables(formData);
    console.log('📝 Template variables for secondary service:', templateVars);
    
    // Add specific debugging for inbox delivery
    console.log('📬 Email delivery debugging:');
    console.log('📬 To Email:', templateVars.to_email);
    console.log('📬 From Email:', templateVars.from_email);
    console.log('📬 Subject:', templateVars.subject);
    
    const result = await sendEmailWithRetry(
      EMAILJS_ADMIN_SERVICE_ID,
      TEMPLATE_IDS.PDF_FORM_ADMIN,
      templateVars,
      EMAILJS_PUBLIC_KEY
    );
    
    if (result.success) {
      console.log('✅ Admin email sent successfully with secondary service:', result);
      console.log('📬 Email Status: SENT - Check your inbox and spam folder');
      console.log('📬 If not in inbox, check EmailJS service configuration');
    } else {
      console.error('❌ Admin email failed with secondary service after all retries:', result);
      console.error('❌ Error details:', result.error);
      console.error('❌ Status code:', result.status);
    }
    
    return result;
  } catch (error) {
    console.error('💥 Failed to send admin email with secondary service:', error);
    console.error('💥 Error stack:', error.stack);
    return { success: false, error: error.message };
  }
};

export const sendPdfFormEmails = async (formData) => {
  console.log('🚀 sendPdfFormEmails called with:', formData)
  
  const validation = validatePdfFormData(formData);
  console.log('📋 Validation result:', validation)
  
  if (!validation.isValid) {
    console.log('❌ Validation failed, stopping email sending')
    return {
      success: false,
      error: 'Validation failed',
      validationErrors: validation.errors
    };
  }

  console.log('✅ Validation passed, proceeding with email sending')

  try {
    // Send admin email first
    console.log('📧 Sending admin email first...')
    const adminResult = await sendPdfFormAdminEmail(formData);
    console.log('📊 Admin result:', adminResult)

    if (!adminResult.success) {
      console.log('❌ Admin email failed, stopping user email')
      return {
        success: false,
        message: 'Admin email failed to send',
        adminError: adminResult.error
      };
    }

    console.log('✅ Admin email sent successfully, now sending user email...')
    
    // Send user email after admin email succeeds
    const userResult = await sendPdfFormUserEmail(formData);
    console.log('📊 User result:', userResult)

    if (userResult.success) {
      console.log('🎉 Both emails sent successfully')
      return {
        success: true,
        message: 'Both emails sent successfully',
        adminResult: adminResult,
        userResult: userResult
      };
    } else {
      console.log('⚠️ Admin email sent, user email failed')
      return {
        success: true,
        message: 'Admin email sent, user email failed',
        adminResult: adminResult,
        userError: userResult.error
      };
    }
  } catch (error) {
    console.error('💥 Unexpected error sending PDF form emails:', error);
    return {
      success: false,
      error: 'Unexpected error occurred',
      details: error.message
    };
  }
};

// Conditional trigger function for secondary service
export const shouldTriggerSecondaryService = (formData) => {
  console.log('🔍 Checking conditions for secondary service trigger...');
  
  // Define conditions that trigger the secondary service
  const conditions = {
    // Always trigger for PDF downloads
    isPdfDownload: true,
    
    // Trigger based on specific email domains
    hasSpecificEmail: formData.email && (
      formData.email.includes('@gmail.com') ||
      formData.email.includes('@yahoo.com') ||
      formData.email.includes('@hotmail.com') ||
      formData.email.includes('@outlook.com')
    ),
    
    // Trigger based on phone number patterns
    hasValidPhone: formData.phone && formData.phone.replace(/\D/g, '').length === 10,
    
    // Trigger based on name length
    hasFullName: formData.fullName && formData.fullName.trim().length >= 5,
    
    // Trigger based on consent
    hasConsent: formData.consent === true,
    
    // Trigger based on time of day (business hours)
    isBusinessHours: () => {
      const now = new Date();
      const hour = now.getHours();
      return hour >= 9 && hour <= 17; // 9 AM to 5 PM
    },
    
    // Trigger based on day of week (weekdays)
    isWeekday: () => {
      const now = new Date();
      const day = now.getDay();
      return day >= 1 && day <= 5; // Monday to Friday
    }
  };
  
  // Calculate trigger score
  let triggerScore = 0;
  const maxScore = 6;
  
  if (conditions.isPdfDownload) triggerScore++;
  if (conditions.hasSpecificEmail) triggerScore++;
  if (conditions.hasValidPhone) triggerScore++;
  if (conditions.hasFullName) triggerScore++;
  if (conditions.hasConsent) triggerScore++;
  if (conditions.isBusinessHours()) triggerScore++;
  if (conditions.isWeekday()) triggerScore++;
  
  const shouldTrigger = triggerScore >= 4; // Trigger if 4 or more conditions are met
  
  console.log('📊 Trigger conditions:', {
    isPdfDownload: conditions.isPdfDownload,
    hasSpecificEmail: conditions.hasSpecificEmail,
    hasValidPhone: conditions.hasValidPhone,
    hasFullName: conditions.hasFullName,
    hasConsent: conditions.hasConsent,
    isBusinessHours: conditions.isBusinessHours(),
    isWeekday: conditions.isWeekday(),
    triggerScore,
    maxScore,
    shouldTrigger
  });
  
  return shouldTrigger;
};

// Enhanced function to send emails to both admin services with conditional trigger
export const sendPdfFormEmailsToBothServices = async (formData) => {
  console.log('🚀 sendPdfFormEmailsToBothServices called with:', formData)
  
  const validation = validatePdfFormData(formData);
  console.log('📋 Validation result:', validation)
  
  if (!validation.isValid) {
    console.log('❌ Validation failed, stopping email sending')
    return {
      success: false,
      error: 'Validation failed',
      validationErrors: validation.errors
    };
  }

  console.log('✅ Validation passed, proceeding with email sending')

  try {
    // Always send admin email to primary service
    console.log('📧 Sending admin email to primary service...')
    const primaryAdminResult = await sendPdfFormAdminEmail(formData);
    console.log('📊 Primary admin result:', primaryAdminResult)

    // Check if we should trigger the secondary service
    const shouldTriggerSecondary = shouldTriggerSecondaryService(formData);
    let secondaryAdminResult = { success: false, skipped: true, reason: 'Conditions not met' };

    if (shouldTriggerSecondary) {
      console.log('📧 Conditions met! Sending admin email to secondary service...')
      secondaryAdminResult = await sendAdminEmailWithSecondaryService(formData);
      console.log('📊 Secondary admin result:', secondaryAdminResult)
    } else {
      console.log('⏭️ Conditions not met, skipping secondary service')
    }

    // Send user confirmation email
    console.log('📧 Sending user confirmation email...')
    const userResult = await sendPdfFormUserEmail(formData);
    console.log('📊 User result:', userResult)

    const primarySuccess = primaryAdminResult.success;
    const secondarySuccess = secondaryAdminResult.success;
    const userSuccess = userResult.success;

    if (primarySuccess && secondarySuccess && userSuccess) {
      console.log('🎉 All emails sent successfully to both services')
      return {
        success: true,
        message: 'All emails sent successfully to both admin services',
        primaryAdminResult: primaryAdminResult,
        secondaryAdminResult: secondaryAdminResult,
        userResult: userResult
      };
    } else if ((primarySuccess || secondarySuccess) && userSuccess) {
      console.log('✅ At least one admin service succeeded, user email sent')
      return {
        success: true,
        message: 'Emails sent to at least one admin service and user',
        primaryAdminResult: primaryAdminResult,
        secondaryAdminResult: secondaryAdminResult,
        userResult: userResult
      };
    } else if (primarySuccess || secondarySuccess) {
      console.log('⚠️ Admin emails sent to at least one service, user email failed')
      return {
        success: true,
        message: 'Admin emails sent to at least one service, user email failed',
        primaryAdminResult: primaryAdminResult,
        secondaryAdminResult: secondaryAdminResult,
        userError: userResult.error
      };
    } else {
      console.log('❌ All admin emails failed')
      return {
        success: false,
        message: 'All admin emails failed to send',
        primaryAdminError: primaryAdminResult.error,
        secondaryAdminError: secondaryAdminResult.error,
        userError: userResult.error
      };
    }
  } catch (error) {
    console.error('💥 Unexpected error sending PDF form emails to both services:', error);
    return {
      success: false,
      error: 'Unexpected error occurred',
      details: error.message
    };
  }
};

// Test function to verify individual services
export const testEmailService = async (serviceId, templateId, testData = null) => {
  console.log('🧪 Testing email service...');
  console.log('📧 Service ID:', serviceId);
  console.log('📧 Template ID:', templateId);
  
  try {
    if (typeof window === 'undefined' || !window.emailjs) {
      throw new Error('EmailJS not available');
    }

    // Use test data or create minimal test data
    const templateVars = testData || {
      full_name: "Test User",
      email: "test@example.com",
      phone_number: "(555) 123-4567",
      consent_given: "Yes",
      page_type: "Test",
      page_path: "/test",
      full_page_url: "https://example.com/test",
      submission_date: new Date().toLocaleDateString(),
      submission_time: new Date().toLocaleTimeString(),
      from_name: "Test User",
      from_email: EMAIL_ADDRESSES.FROM,
      to_email: EMAIL_ADDRESSES.ADMIN,
      subject: "Test Email from service_ssbinbm"
    };

    console.log('📝 Sending test email with variables:', templateVars);
    
    const result = await window.emailjs.send(
      serviceId,
      templateId,
      templateVars,
      EMAILJS_PUBLIC_KEY
    );
    
    console.log('✅ Test email sent successfully:', result);
    return { success: true, result };
    
  } catch (error) {
    console.error('❌ Test email failed:', error);
    console.error('❌ Error details:', {
      status: error.status,
      text: error.text,
      message: error.message
    });
    return { success: false, error: error.message, status: error.status };
  }
};

// Test both services individually
export const testBothEmailServices = async (formData) => {
  console.log('🧪 Testing both email services individually...');
  
  const results = {
    primary: null,
    secondary: null
  };
  
  // Test primary service
  console.log('🔍 Testing primary service (service_4kan9lv)...');
  results.primary = await testEmailService(
    EMAILJS_SERVICE_ID,
    TEMPLATE_IDS.PDF_FORM_ADMIN,
    formData ? formatPdfFormTemplateVariables(formData) : null
  );
  
  // Test secondary service
  console.log('🔍 Testing secondary service (service_ssbinbm)...');
  results.secondary = await testEmailService(
    EMAILJS_ADMIN_SERVICE_ID,
    TEMPLATE_IDS.PDF_FORM_ADMIN,
    formData ? formatPdfFormTemplateVariables(formData) : null
  );
  
  console.log('📊 Test results:', results);
  return results;
};

// Force trigger secondary service for testing
export const forceTriggerSecondaryService = async (formData) => {
  console.log('🚀 Force triggering secondary service...');
  
  try {
    const result = await sendAdminEmailWithSecondaryService(formData);
    console.log('📊 Force trigger result:', result);
    return result;
  } catch (error) {
    console.error('💥 Error force triggering secondary service:', error);
    return { success: false, error: error.message };
  }
};

// Test conditional trigger logic
export const testConditionalTrigger = (formData) => {
  console.log('🧪 Testing conditional trigger logic...');
  const shouldTrigger = shouldTriggerSecondaryService(formData);
  console.log('📊 Should trigger secondary service:', shouldTrigger);
  return shouldTrigger;
};

// Diagnostic function for EmailJS configuration
export const diagnoseEmailJSConfiguration = () => {
  console.log('🔍 EmailJS Configuration Diagnosis:');
  console.log('=====================================');
  
  // Check EmailJS availability
  console.log('📧 EmailJS Available:', typeof window !== 'undefined' && window.emailjs ? 'YES' : 'NO');
  
  // Check service IDs
  console.log('🔧 Primary Service ID:', EMAILJS_SERVICE_ID);
  console.log('🔧 Secondary Service ID:', EMAILJS_ADMIN_SERVICE_ID);
  
  // Check template IDs
  console.log('📝 Template IDs:', TEMPLATE_IDS);
  
  // Check email addresses
  console.log('📬 Email Addresses:', EMAIL_ADDRESSES);
  
  // Check public key
  console.log('🔑 Public Key:', EMAILJS_PUBLIC_KEY);
  
  // Common issues and solutions
  console.log('🚨 Common Issues & Solutions:');
  console.log('=============================');
  console.log('1. Emails in SENT but not INBOX:');
  console.log('   - Check EmailJS service configuration');
  console.log('   - Verify "To Email" field in template');
  console.log('   - Check spam/junk folder');
  console.log('   - Verify email provider settings');
  
  console.log('2. Service Configuration Issues:');
  console.log('   - Ensure service_ssbinbm exists in EmailJS dashboard');
  console.log('   - Verify template_uhpo60t exists in service_ssbinbm');
  console.log('   - Check if public key has access to both services');
  
  console.log('3. Template Issues:');
  console.log('   - Verify "To Email" field is set correctly');
  console.log('   - Check if template variables match');
  console.log('   - Ensure template is published and active');
  
  console.log('4. Email Provider Issues:');
  console.log('   - Check if receiving email provider blocks automated emails');
  console.log('   - Verify email address is correct');
  console.log('   - Check if email provider has delivery restrictions');
  
  return {
    emailjsAvailable: typeof window !== 'undefined' && window.emailjs,
    primaryServiceId: EMAILJS_SERVICE_ID,
    secondaryServiceId: EMAILJS_ADMIN_SERVICE_ID,
    templateIds: TEMPLATE_IDS,
    emailAddresses: EMAIL_ADDRESSES,
    publicKey: EMAILJS_PUBLIC_KEY
  };
};

// Template variable formatters for Claim Review form
export const formatClaimReviewTemplateVariables = (formData) => {
  const currentDate = new Date();
  const pagePath = typeof window !== 'undefined' ? window.location.pathname : "Unknown";
  const fullPageUrl = typeof window !== 'undefined' ? window.location.href : "Unknown";
  
  // Determine eligibility
  const isEligible = formData.involved === 'yes' && formData.injured === 'yes';
  
  // Format phone number (ensure 10 digits)
  const phoneNumber = formData.phone ? formData.phone.replace(/\D/g, '').slice(0, 10) : "Not provided";
  
  return {
    // Form data
    full_name: formData.fullName || "Not provided",
    phone_number: phoneNumber,
    email: formData.email || "Not provided",
    involved_in_accident: formData.involved === 'yes' ? 'Yes' : (formData.involved === 'no' ? 'No' : 'Not specified'),
    injured_hospitalized: formData.injured === 'yes' ? 'Yes' : (formData.injured === 'no' ? 'No' : 'Not specified'),
    accident_timing: formData.time || 'Not specified',
    eligibility_status: isEligible ? 'eligible' : 'not-eligible',
    eligibility_status_text: isEligible ? 'Eligible' : 'Not Eligible',
    tcpa_consent: formData.tcpaConsent ? 'Yes' : 'No',
    
    // Technical data
    page_path: pagePath,
    full_page_url: fullPageUrl,
    ip_address: 'N/A', // You may want to get this from a service
    submission_date: currentDate.toLocaleDateString('en-US', {
      weekday: 'long',
      year: 'numeric',
      month: 'long',
      day: 'numeric'
    }),
    submission_time: currentDate.toLocaleTimeString('en-US', {
      hour: '2-digit',
      minute: '2-digit',
      second: '2-digit',
      hour12: true
    }),
    
    // Email configuration
    from_name: formData.fullName || "Claim Review User",
    from_email: EMAIL_ADDRESSES.FROM,
    to_email: EMAIL_ADDRESSES.ADMIN,
    subject: `New Claim Review Submission - ${isEligible ? 'Eligible' : 'Not Eligible'} - ${formData.fullName || 'Anonymous'}`
  };
};

// Validation functions for Claim Review form
export const validateClaimReviewFormData = (formData) => {
  const errors = [];
  
  if (!formData.fullName || formData.fullName.trim().length < 2) {
    errors.push("Full name is required (minimum 2 characters)");
  }
  
  if (!formData.phone || formData.phone.replace(/\D/g, '').length !== 10) {
    errors.push("Valid 10-digit phone number is required");
  }
  
  if (!formData.email || !formData.email.includes('@')) {
    errors.push("Valid email address is required");
  }
  
  if (!formData.involved) {
    errors.push("Please answer if you were involved in an accident");
  }
  
  if (!formData.injured) {
    errors.push("Please answer if you were injured and hospitalized");
  }
  
  if (!formData.time) {
    errors.push("Please specify when the accident happened");
  }
  
  if (!formData.tcpaConsent) {
    errors.push("Consent to terms and conditions is required");
  }
  
  return {
    isValid: errors.length === 0,
    errors
  };
};

// Email sending functions for Claim Review form
export const sendClaimReviewAdminEmail = async (formData) => {
  try {
    if (typeof window === 'undefined' || !window.emailjs) {
      throw new Error('EmailJS not available');
    }

    const templateVars = formatClaimReviewTemplateVariables(formData);
    
    const result = await sendEmailWithRetry(
      EMAILJS_SERVICE_ID,
      TEMPLATE_IDS.CLAIM_REVIEW_ADMIN,
      templateVars,
      EMAILJS_PUBLIC_KEY
    );
    
    if (result.success) {
      console.log('Claim Review admin email sent successfully:', result);
    } else {
      console.error('Claim Review admin email failed after all retries:', result);
    }
    
    return result;
  } catch (error) {
    console.error('Failed to send Claim Review admin email:', error);
    return { success: false, error: error.message };
  }
};

export const sendClaimReviewUserEmail = async (formData) => {
  try {
    if (typeof window === 'undefined' || !window.emailjs) {
      throw new Error('EmailJS not available');
    }

    const templateVars = formatClaimReviewTemplateVariables(formData);
    
    // User template only needs name and timestamps
    const userTemplateVars = {
      full_name: templateVars.full_name,
      submission_date: templateVars.submission_date,
      submission_time: templateVars.submission_time
    };
    
    const result = await sendEmailWithRetry(
      EMAILJS_SERVICE_ID,
      TEMPLATE_IDS.CLAIM_REVIEW_USER,
      userTemplateVars,
      EMAILJS_PUBLIC_KEY
    );
    
    if (result.success) {
      console.log('Claim Review user confirmation email sent successfully:', result);
    } else {
      console.error('Claim Review user confirmation email failed after all retries:', result);
    }
    
    return result;
  } catch (error) {
    console.error('Failed to send Claim Review user confirmation email:', error);
    return { success: false, error: error.message };
  }
};

export const sendClaimReviewEmails = async (formData) => {
  console.log('🚀 sendClaimReviewEmails called with:', formData)
  
  const validation = validateClaimReviewFormData(formData);
  console.log('📋 Validation result:', validation)
  
  if (!validation.isValid) {
    console.log('❌ Validation failed, stopping email sending')
    return {
      success: false,
      error: 'Validation failed',
      validationErrors: validation.errors
    };
  }

  console.log('✅ Validation passed, proceeding with email sending')

  try {
    // Send admin email first
    console.log('📧 Sending admin email first...')
    const adminResult = await sendClaimReviewAdminEmail(formData);
    console.log('📊 Admin result:', adminResult)

    if (!adminResult.success) {
      console.log('❌ Admin email failed, stopping user email')
      return {
        success: false,
        message: 'Admin email failed to send',
        adminError: adminResult.error
      };
    }

    console.log('✅ Admin email sent successfully, now sending user email...')
    
    // Send user email after admin email succeeds
    const userResult = await sendClaimReviewUserEmail(formData);
    console.log('📊 User result:', userResult)

    if (userResult.success) {
      console.log('🎉 Both emails sent successfully')
      return {
        success: true,
        message: 'Both emails sent successfully',
        adminResult: adminResult,
        userResult: userResult
      };
    } else {
      console.log('⚠️ Admin email sent, user email failed')
      return {
        success: true,
        message: 'Admin email sent, user email failed',
        adminResult: adminResult,
        userError: userResult.error
      };
    }
  } catch (error) {
    console.error('💥 Unexpected error sending Claim Review emails:', error);
    return {
      success: false,
      error: 'Unexpected error occurred',
      details: error.message
    };
  }
};

export default {
  EMAILJS_PUBLIC_KEY,
  EMAILJS_SERVICE_ID,
  EMAILJS_ADMIN_SERVICE_ID,
  TEMPLATE_IDS,
  EMAIL_ADDRESSES,
  PAGE_TYPES,
  FORM_FIELD_MAPPINGS,
  initializeEmailJS,
  formatTemplateVariables,
  formatPdfFormTemplateVariables,
  formatClaimReviewTemplateVariables,
  validateFormData,
  validatePdfFormData,
  validateClaimReviewFormData,
  sendPdfFormAdminEmail,
  sendPdfFormUserEmail,
  sendPdfFormEmails,
  sendClaimReviewAdminEmail,
  sendClaimReviewUserEmail,
  sendClaimReviewEmails,
  sendAdminEmailWithSecondaryService,
  sendPdfFormEmailsToBothServices,
  shouldTriggerSecondaryService,
  forceTriggerSecondaryService,
  testConditionalTrigger,
  testEmailService,
  testBothEmailServices,
  diagnoseEmailJSConfiguration,
  EMAIL_CONFIG
}; 